import React, { useState } from 'react';
import { SendIcon, MessageSquareIcon, UserIcon, HeartIcon, AlertCircleIcon, CheckIcon } from 'lucide-react';
interface Message {
  id: number;
  user: string;
  text: string;
  timestamp: Date;
  likes: number;
  isLiked: boolean;
  avatar: string;
  isVerified?: boolean;
}
const FanConnection = () => {
  const [messages, setMessages] = useState<Message[]>([{
    id: 1,
    user: 'CosmicTraveler',
    text: "Just discovered Fabric Reality through the Exhibition visualizer and I'm completely blown away! The synth work is incredible.",
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2),
    likes: 15,
    isLiked: false,
    avatar: 'https://api.dicebear.com/6.x/personas/svg?seed=CosmicTraveler'
  }, {
    id: 2,
    user: 'StellarSoundwave',
    text: "Saw you guys live in London last month. The energy was out of this world! Can't wait for the next show.",
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 5),
    likes: 8,
    isLiked: false,
    avatar: 'https://api.dicebear.com/6.x/personas/svg?seed=StellarSoundwave'
  }, {
    id: 3,
    user: 'FabricRealityOfficial',
    text: "Thank you all for the amazing support! We're working on new music that we can't wait to share with you soon. Stay tuned for some cosmic announcements!",
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 8),
    likes: 42,
    isLiked: false,
    avatar: 'https://api.dicebear.com/6.x/personas/svg?seed=FabricRealityOfficial',
    isVerified: true
  }, {
    id: 4,
    user: 'NebulaRider',
    text: "Sunset On Saturn has been on repeat for weeks. The production is so immersive, feels like I'm actually floating through space.",
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 12),
    likes: 23,
    isLiked: false,
    avatar: 'https://api.dicebear.com/6.x/personas/svg?seed=NebulaRider'
  }, {
    id: 5,
    user: 'AstralEcho',
    text: 'The lyrics in How It Feels To Love You Lately really hit home. Thank you for creating such meaningful music.',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24),
    likes: 19,
    isLiked: false,
    avatar: 'https://api.dicebear.com/6.x/personas/svg?seed=AstralEcho'
  }]);
  const [newMessage, setNewMessage] = useState('');
  const [username, setUsername] = useState('');
  const [showUsernamePrompt, setShowUsernamePrompt] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [activeTab, setActiveTab] = useState<'community' | 'updates'>('community');
  const handleLike = (id: number) => {
    setMessages(prev => prev.map(message => {
      if (message.id === id) {
        return {
          ...message,
          likes: message.isLiked ? message.likes - 1 : message.likes + 1,
          isLiked: !message.isLiked
        };
      }
      return message;
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newMessage.trim()) {
      setErrorMessage("Message can't be empty");
      setTimeout(() => setErrorMessage(''), 3000);
      return;
    }
    if (!username) {
      setShowUsernamePrompt(true);
      return;
    }
    const newMsg: Message = {
      id: Date.now(),
      user: username,
      text: newMessage,
      timestamp: new Date(),
      likes: 0,
      isLiked: false,
      avatar: `https://api.dicebear.com/6.x/personas/svg?seed=${username}`
    };
    setMessages(prev => [newMsg, ...prev]);
    setNewMessage('');
  };
  const submitUsername = () => {
    if (!username.trim()) {
      setErrorMessage("Username can't be empty");
      return;
    }
    setShowUsernamePrompt(false);
    setErrorMessage('');
  };
  const formatTimestamp = (date: Date) => {
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / (1000 * 60));
    if (diffMins < 1) return 'just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours}h ago`;
    const diffDays = Math.floor(diffHours / 24);
    if (diffDays < 30) return `${diffDays}d ago`;
    return date.toLocaleDateString();
  };
  // Filter messages based on the active tab
  const filteredMessages = activeTab === 'community' ? messages : messages.filter(message => message.isVerified);
  return <section className="pt-28 md:pt-36 pb-16" data-id="element-126">
      <div className="max-w-4xl mx-auto" data-id="element-127">
        <h2 className="text-5xl font-bold mb-12 font-mono text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 inline-block" data-id="element-128">
          FAN CONNECTION
        </h2>
        <div className="bg-black/60 backdrop-blur-sm rounded-lg border border-indigo-500/30 shadow-lg shadow-indigo-500/20 overflow-hidden" data-id="element-129">
          <div className="border-b border-gray-800" data-id="element-130">
            <div className="flex" data-id="element-131">
              <button className={`px-6 py-4 font-medium text-sm flex items-center ${activeTab === 'community' ? 'text-white border-b-2 border-pink-500' : 'text-gray-400 hover:text-gray-300'}`} onClick={() => setActiveTab('community')} data-id="element-132">
                <MessageSquareIcon size={18} className="mr-2" data-id="element-133" />
                COMMUNITY
              </button>
              <button className={`px-6 py-4 font-medium text-sm flex items-center ${activeTab === 'updates' ? 'text-white border-b-2 border-pink-500' : 'text-gray-400 hover:text-gray-300'}`} onClick={() => setActiveTab('updates')} data-id="element-134">
                <UserIcon size={18} className="mr-2" data-id="element-135" />
                OFFICIAL UPDATES
              </button>
            </div>
          </div>
          <div className="p-6" data-id="element-136">
            <div className="flex items-center justify-between mb-6" data-id="element-137">
              <h3 className="text-2xl font-semibold text-white" data-id="element-138">
                {activeTab === 'community' ? 'The Cosmic Community' : 'Official Updates'}
              </h3>
              <div className="bg-indigo-900/50 px-3 py-1 rounded-full text-sm text-indigo-300 font-mono" data-id="element-139">
                {filteredMessages.length}{' '}
                {activeTab === 'community' ? 'messages' : 'updates'}
              </div>
            </div>
            {/* Message Form - only show in community tab */}
            {activeTab === 'community' && <form onSubmit={handleSubmit} className="mb-8" data-id="element-140">
                <div className="flex gap-2" data-id="element-141">
                  <input type="text" value={newMessage} onChange={e => setNewMessage(e.target.value)} placeholder="Share your thoughts with other fans..." className="flex-grow px-4 py-3 bg-gray-900/70 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-pink-500 text-white" data-id="element-142" />
                  <button type="submit" className="px-4 py-3 bg-pink-600 hover:bg-pink-700 text-white rounded-lg transition-colors" data-id="element-143">
                    <SendIcon size={20} data-id="element-144" />
                  </button>
                </div>
                {errorMessage && <p className="text-red-400 mt-2 text-sm flex items-center" data-id="element-145">
                    <AlertCircleIcon size={14} className="mr-1" data-id="element-146" />
                    {errorMessage}
                  </p>}
              </form>}
            {/* Messages */}
            <div className="space-y-6" data-id="element-147">
              {filteredMessages.length > 0 ? filteredMessages.map(message => <div key={message.id} className="flex gap-4" data-id="element-148">
                    <div className="flex-shrink-0" data-id="element-149">
                      <div className="w-10 h-10 rounded-full overflow-hidden bg-indigo-900/50" data-id="element-150">
                        <img src={message.avatar} alt={message.user} className="w-full h-full object-cover" data-id="element-151" />
                      </div>
                    </div>
                    <div className="flex-grow" data-id="element-152">
                      <div className="flex items-center gap-2 mb-1" data-id="element-153">
                        <span className="font-semibold text-white" data-id="element-154">
                          {message.user}
                        </span>
                        {message.isVerified && <span className="bg-blue-500 text-white p-0.5 rounded-full" title="Verified Artist" data-id="element-155">
                            <CheckIcon size={12} data-id="element-156" />
                          </span>}
                        <span className="text-xs text-gray-400" data-id="element-157">
                          {formatTimestamp(message.timestamp)}
                        </span>
                      </div>
                      <p className="text-gray-300 mb-2" data-id="element-158">{message.text}</p>
                      <button onClick={() => handleLike(message.id)} className={`flex items-center gap-1 text-sm ${message.isLiked ? 'text-pink-500' : 'text-gray-400 hover:text-pink-400'}`} data-id="element-159">
                        <HeartIcon size={14} fill={message.isLiked ? '#ec4899' : 'none'} data-id="element-160" />
                        <span data-id="element-161">{message.likes}</span>
                      </button>
                    </div>
                  </div>) : <div className="text-center py-8" data-id="element-162">
                  <div className="w-16 h-16 mx-auto bg-gray-800 rounded-full flex items-center justify-center mb-4" data-id="element-163">
                    <MessageSquareIcon size={24} className="text-gray-400" data-id="element-164" />
                  </div>
                  <h4 className="text-lg font-medium text-white mb-2" data-id="element-165">
                    No messages yet
                  </h4>
                  <p className="text-gray-400" data-id="element-166">
                    Be the first to share your thoughts!
                  </p>
                </div>}
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8" data-id="element-167">
          <div className="bg-black/40 backdrop-blur-sm p-6 rounded-lg border border-indigo-500/10" data-id="element-168">
            <h3 className="text-xl font-semibold text-white mb-4 flex items-center" data-id="element-169">
              <MessageSquareIcon size={20} className="mr-2 text-pink-400" data-id="element-170" />
              Community Guidelines
            </h3>
            <ul className="text-gray-300 space-y-2" data-id="element-171">
              <li data-id="element-172">• Be respectful to other fans and the band</li>
              <li data-id="element-173">• No spam, advertising, or self-promotion</li>
              <li data-id="element-174">• Keep discussions related to Fabric Reality</li>
              <li data-id="element-175">• No hate speech or offensive content</li>
              <li data-id="element-176">• Have fun and share your cosmic journey!</li>
            </ul>
          </div>
          <div className="bg-black/40 backdrop-blur-sm p-6 rounded-lg border border-indigo-500/10" data-id="element-177">
            <h3 className="text-xl font-semibold text-white mb-4 flex items-center" data-id="element-178">
              <UserIcon size={20} className="mr-2 text-pink-400" data-id="element-179" />
              Connect With Us
            </h3>
            <p className="text-gray-300 mb-4" data-id="element-180">
              Follow Fabric Reality on social media for the latest updates,
              behind-the-scenes content, and exclusive announcements.
            </p>
            <div className="flex space-x-3" data-id="element-181">
              <a href="#" className="bg-gray-800 hover:bg-gray-700 p-2 rounded-full text-white transition-colors" data-id="element-182">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-183">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-184"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-185"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" data-id="element-186"></line>
                </svg>
              </a>
              <a href="#" className="bg-gray-800 hover:bg-gray-700 p-2 rounded-full text-white transition-colors" data-id="element-187">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-188">
                  <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" data-id="element-189"></path>
                </svg>
              </a>
              <a href="#" className="bg-gray-800 hover:bg-gray-700 p-2 rounded-full text-white transition-colors" data-id="element-190">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-191">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" data-id="element-192"></path>
                </svg>
              </a>
              <a href="#" className="bg-gray-800 hover:bg-gray-700 p-2 rounded-full text-white transition-colors" data-id="element-193">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-194">
                  <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z" data-id="element-195"></path>
                  <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" data-id="element-196"></polygon>
                </svg>
              </a>
            </div>
          </div>
        </div>
        {/* Username Prompt Modal */}
        {showUsernamePrompt && <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4 backdrop-blur-sm" data-id="element-197">
            <div className="bg-gray-900 rounded-lg p-6 max-w-md w-full border border-pink-500/30" data-id="element-198">
              <h3 className="text-xl font-semibold text-white mb-4" data-id="element-199">
                Choose a Username
              </h3>
              <p className="text-gray-300 mb-6" data-id="element-200">
                Please choose a username to identify yourself in the Fabric
                Reality community.
              </p>
              <div className="mb-6" data-id="element-201">
                <label htmlFor="username" className="block text-gray-300 mb-2" data-id="element-202">
                  Username
                </label>
                <input id="username" type="text" value={username} onChange={e => setUsername(e.target.value)} className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-pink-500 text-white" placeholder="e.g. CosmicExplorer" data-id="element-203" />
                {errorMessage && <p className="text-red-400 mt-2 text-sm flex items-center" data-id="element-204">
                    <AlertCircleIcon size={14} className="mr-1" data-id="element-205" />
                    {errorMessage}
                  </p>}
              </div>
              <div className="flex justify-end space-x-3" data-id="element-206">
                <button onClick={() => {
              setShowUsernamePrompt(false);
              setErrorMessage('');
            }} className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg" data-id="element-207">
                  Cancel
                </button>
                <button onClick={submitUsername} className="px-6 py-2 bg-gradient-to-r from-pink-600 to-purple-600 text-white font-medium rounded-lg transition-all duration-300 hover:from-pink-500 hover:to-purple-500" data-id="element-208">
                  Continue
                </button>
              </div>
            </div>
          </div>}
      </div>
    </section>;
};
export default FanConnection;